import styled from 'styled-components';
import {COLOR} from '../constants';

export const LoadingContainer = styled.div`
  align-items: center;
  background-color: rgba(0,0,0,0.4);
  bottom: 0;
  color: #DDDDDD;
  display: ${({loading}) => loading ? 'flex' : 'none'};
  font-size: 2vw;
  flex-direction: column;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 9;
`;

export const LoadingProgressContainer = styled.div`
  background-color: #33333355;
  border: 2px solid #BBBBBBB;
  border-radius: 8px;
  height: 30px;
  overflow: hidden;
  position: relative;
  width: 40%;
`;

export const LoadingProgress = styled.div`
  background-color: ${COLOR.PRIMARY};
  border-radius: 0 8px 8px 0;
  box-shadow:rgba(0,0,0,.2) 2px 0 10px;
  bottom: 0;
  height: 100%;
  position: absolute;
  left: 0;
  right: ${({progress=0}) => (1-progress)*100}%;
  top: 0;
`;


export const LoadingContentContainer = styled.div`
  align-items: center;
  background-color: rgba(0,0,0,0.2);
  backdrop-filter: blur(3px);
  border-radius: 3px;
  color: #DDDDDD;
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  img{
    max-width: 50px;
  }
`;

export const CSSSpinner = styled.div`
  width: 50px;
  height: 50px;
  border: 4px solid rgba(52, 183, 229, 0.2);
  border-top: 4px solid ${COLOR.PRIMARY};
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    border: 4px solid ${COLOR.PRIMARY};
    opacity: 0.6;
  }
`;

export const VisuallyHidden = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
`;